import * as React from "react"
import { Link } from "react-router-dom"

import { cn } from "@/utils"

export interface EmptyWidgetProps {
  /** Icon element to display */
  icon?: React.ReactNode
  /** Title text */
  title: string
  /** Description text */
  description?: string
  /** Optional CTA action */
  action?: {
    label: string
    to?: string
    onClick?: () => void
  }
  /** Additional className */
  className?: string
}

function EmptyWidget({ icon, title, description, action, className }: EmptyWidgetProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-8 px-4 text-center", className)}>
      {icon && (
        <div className="mb-3 text-muted-foreground">{icon}</div>
      )}
      <p className="text-sm font-medium text-foreground">{title}</p>
      {description && (
        <p className="mt-1 text-xs text-muted-foreground max-w-xs">{description}</p>
      )}
      {action && (
        action.to ? (
          <Link
            to={action.to}
            className="mt-3 inline-flex items-center gap-1 rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            {action.label}
          </Link>
        ) : (
          <button
            onClick={action.onClick}
            className="mt-3 inline-flex items-center gap-1 rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            {action.label}
          </button>
        )
      )}
    </div>
  )
}

export { EmptyWidget }
